<template>
  <div class="step-content py-4 text-left">
    <v-progress-linear
      v-if="step.evaluation.score==null"
      indeterminate
      color="secondary"
      class="mb-4"
    />
    <div 
      v-else-if="showEvaluation"
      class="score-display mb-4"
    >
      <div class="evaluation-bar d-flex v-progress-linear theme--dark">
        <div class="evaluation-bar-grade v-progress-linear__determinate red" />
        <div class="evaluation-bar-grade v-progress-linear__determinate orange" />
        <div class="evaluation-bar-grade v-progress-linear__determinate yellow" />
        <div class="evaluation-bar-grade v-progress-linear__determinate light-green" />
        <div class="evaluation-bar-grade v-progress-linear__determinate primary darken-1" />
      </div>
      <div 
        class="score-pointer elevation-12" 
        :class="evaluationColor"
        :style="{ 'left': (step.evaluation.score*100) + '%' }"
      />
    </div>

    <v-list 
      v-if="step.evaluation.feedbacks.length>0"
      two-line
      color="transparent"
      class="feedbacks my-6"
    >
      <v-list-item
        v-for="item in step.evaluation.feedbacks"
        :key="item.criteria"
        class="px-0"
      >
        <v-list-item-icon class="icon">
          <v-icon color="amber">
            {{ icons.mdiAlertCircleOutline }}
          </v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title
            class="item-title"
          >
            {{ $t('signup.steps.FDB.feedbacks.'+item.criteria+'.label') }}
          </v-list-item-title>
          <v-list-item-subtitle
            class="item-subtitle"
          >
            {{ getFeedback(item) }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <div
      class="instruction text-center my-12"
    >
      <img 
        src="@/assets/instruction-icon.svg"
        class="mb-4"
      >
      <h6 class="text-h6">
        {{ $t('signup.steps.FDB.process.title') }}
      </h6>
      <p class="text-body-1 mt-4 mb-3">
        {{ $t('signup.steps.FDB.process.subtitle') }}
      </p>
      <v-divider 
        class="mt-0 mx-auto" 
        style="max-width: 25vw;"
      />
      <!-- TODO -->
      <p 
        v-html="openning.text" 
        class="text-body-2 mt-4 px-4" 
      />
    </div>

    <div
      class="steps-timeline text-center my-10"
    >
      <h6 class="text-h6 my-4">
        {{ $t('signup.steps.FDB.process.title') }}
      </h6>
      <v-timeline
        align-top
        clipped
        dense
        class="text-left"
      >
        <v-timeline-item
          v-for="(item, index) in timelineItems"
          :key="index"
          color="transparent"
          :icon-color="item.iconColor"
          large
          class=""
        >
          <template v-slot:icon>
            <v-icon :color="item.iconColor">{{ icons[item.icon] }}</v-icon>
          </template>
          <p class="text-subtitle-1 ml-2 mb-0">
            {{ $t(item.titleKey) }}
          </p>
          <p
            class="text-body-2 ml-2 mb-0"
            :class="item.youAreHere ? 'primary--text font-weight-medium' : 'text--secondary'"
          >
            {{ item.subtitleKey ? $t(item.subtitleKey) : openning.date }}
          </p>
        </v-timeline-item>
      </v-timeline>

      <p class="text-body-2 mt-8">
        {{ $t('signup.steps.FDB.update_profile') }}
      </p>
      <v-btn
        color="primary"
        text
        class="my-2"
        @click="toggleView('profile')"
      >
        <v-icon
          small
          class="mr-4 ml-n1"
        >
          {{ icons.mdiAccountCircle }}
        </v-icon>
        {{ $t('general.refresh_thing', { thing: $t('general.profile') }) }}
      </v-btn>
    </div>
    

    <!-- <v-btn 
      text
      small
      class="help-btn mt-n2 mb-8"
      color="grey lighten-2"
      @click="toggleHelp(true, 'signup')"
    >
      <v-icon
        small
        class="mr-4 ml-n1"
      >
        {{ icons.mdiHelpCircleOutline }}
      </v-icon>
      Alguma dúvida?
    </v-btn> -->
      <!-- <v-alert 
        v-show="openning.toggle"
        color="primary"
        text
        transition="expand-transition"
        :icon="icons.mdiClockOutline"
        class="openning body-2 pa-4 mb-2"
      >
        <h5 class="subtitle-1 font-weight-medium">
          O que acontece agora?
        </h5>
        <span v-html="openning.text" /> <br>
        <span v-if="openning.date!='–'&&openning.date!=null">
          Previsão de abertura: <b>{{ openning.date }}</b>
        </span>
      </v-alert> -->

    <v-card 
      outlined
      color="transparent"
      class="faq mx-n4 my-8"
    >
      <v-list 
        flat
        color="transparent"
        class="py-0"
      >
        <v-list-item
          class="faq-item py-2"
        >
          <v-list-item-icon class="mr-4">
            <v-icon color="primary">{{ icons.mdiHelpCircleOutline }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title class="text-subtitle-1 font-weight-medium">
              {{ $t('signup.faq.title') }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          v-for="(faq, key) in faq"
          :key="key"
          class="faq-item py-1"
          @click="toggleHelp(true, 'signup', faq.section, faq.item)"
        >
          <v-list-item-title v-text="!!helpContent ? (helpContent[faq.section].items[faq.item]).title : null" />
        </v-list-item>
      </v-list>
      <v-divider class="mt-0" />
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          text
          @click="toggleHelp(true, 'signup')"
        >
          {{ $t('general.see_thing', { thing: $t('general.more') }) }}
        </v-btn>
      </v-card-actions>
    </v-card>

    <slot name="quick-access" />

    <!-- <v-card 
      v-if="device.isAndroid&&!user.profile.gps"
      outlined
      color="transparent"
      class="alerts mx-n4"
    >
      <v-card-text>
        <div class="subtitle-1">
          Habilite o GPS
        </div>
        <div class="mt-2 body-2">
          Para garantir uma avaliação mais justa, permita o compartilhamento de seu GPS. Fique tranquilo, suas informações estão seguras conosco.
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          text
          @click="enableGeolocation"
        >
          Habilitar GPS
        </v-btn>
      </v-card-actions>
    </v-card> -->

      <!-- <div
        v-if="!user.profile.push"
        class="px-0"
      >
        <v-card-text>
          <div class="subtitle-1">
            Fique atento às notificações!
          </div>
          <div class="mt-2 body-2">
            Quando tivermos novidades vamos enviar notificação aqui no app Parceiros.
          </div>
        </v-card-text>
        <v-divider />
      </div>
      <div
        v-else
        class="px-0"
      >
        <v-card-text>
          <div class="subtitle-1">
            Ative as Notificações
          </div>
          <div class="mt-2 body-2">
            Queremos avisar quando tivermos notícias! Para isso habilite as notificações para nosso app.
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="primary"
            text
            @click="enablePush"
          >
            Ativar Notificações
          </v-btn>
        </v-card-actions>
        <v-divider />
      </div> -->

    <referral-card 
      v-if="!!helpContent?.referrals"
      :user="user"
      bonus
      @help="toggleHelp"
    />

    <div
      class="social text-center mt-8"
    >
      <!-- <h5 class="py-2 body-2 text--secondary">
        Siga nossas redes sociais
      </h5> -->
      <v-btn
        v-for="item in social"
        :key="item.title"
        class="social-link my-4"
        style="max-width: 50vw"
        text
        large
        block
        @click="openURL(item.url)"
      >
        <v-icon
          class="mr-4"
          color="secondary"
        >
          {{ icons[item.icon] }}
        </v-icon>
        {{ $t(item.title) }}
      </v-btn>
      <v-btn 
        text
        small
        class="help-btn mt-6"
        color="grey"
        @click="toggleHelp(true, 'signup')"
      >
        <v-icon
          small
          class="mr-4"
        >
          {{ icons.mdiHelpCircleOutline }}
        </v-icon>
        {{ $t('general.need_help') }}
      </v-btn>
    </div>
  </div>
</template>

<style>

  .score-display {
    position: relative;
  }
  .evaluation-bar {
    height: 16px;
    border-radius: 4px;
  }
  .evaluation-bar .evaluation-bar-grade {
    position: relative;
    left: auto;
    width: 20%;
    height: 16px;
    opacity: .75;
  }
  .score-display .score-pointer {
    position: absolute;
    top: -8px;
    width: 32px;
    height: 32px;
    transform: translateX(-50%);
    border-radius: 4px;
  }

  .step-content .icon {
    margin-right: 16px !important;
  }
  .step-content .item-title {
    margin: 6px 0;
  }

  .step-content .item-subtitle {
    line-height: 1.4;
    text-overflow: initial;
    white-space: initial;
  }

  .step-content .alerts, .step-content .faq {
    max-width: initial;
    border-color: var(--v-grey-darken3) !important;
  }

  .step-content .faq .faq-item:not(:last-child) {
    border-bottom: 1px solid var(--v-grey-darken3) !important;
  }

</style>

<script>

  // Icons
  import {
    mdiAlertCircleOutline,
    mdiBell,
    mdiMapMarker,
    mdiClockOutline,
    mdiClose,
    mdiInstagram,
    mdiWeb,
    mdiPostOutline,
    mdiHelpCircleOutline,
    mdiAccountCircle,
    mdiCardAccountDetailsOutline,
    mdiClipboardCheckOutline,
    mdiFileSearchOutline,
    mdiFilterOutline,
    mdiCarClock
  } from '@mdi/js'

  // Utilities
  import services from '@/services.js'
  import { sync, get } from 'vuex-pathify'
  import _ from 'lodash';
  import { Capacitor } from '@capacitor/core';


  export default {
    name: 'Step2',

    props: {
      step: {
        type: Object,
        default: () => {}
      },
      helpContent: {
        type: Object,
        default: () => {}
      },
      appURL: {
        type: String,
        default: ''
      },
      device: {
        type: Object,
        default: () => null
      }
    },

    components: {
      ReferralCard: () => import('@/components/ReferralCard'),
      // CompletionProgress: () => import('@/components/CompletionProgress'),
    },

    data: () => ({
      api: process.env.VUE_APP_ROOT_API,
      icons: {
        mdiAlertCircleOutline,
        mdiBell,
        mdiMapMarker,
        mdiClockOutline,
        mdiClose,
        mdiInstagram,
        mdiWeb,
        mdiPostOutline,
        mdiHelpCircleOutline,
        mdiAccountCircle,
        mdiCardAccountDetailsOutline,
        mdiClipboardCheckOutline,
        mdiFileSearchOutline,
        mdiFilterOutline,
        mdiCarClock
      },
      timeline: {
        order: [[0,1,2,3,4], [0,1,3,2,4]],
        items:[
          {
            icon: 'mdiCardAccountDetailsOutline',
            iconColor: 'primary',
            titleKey: 'signup.steps.FDB.process.signup',
            subtitleKey: 'signup.steps.FDB.process.beginning',
            youAreHere: false
          },
          {
            icon: 'mdiClipboardCheckOutline',
            iconColor: 'primary',
            titleKey: 'signup.steps.FDB.process.evaluation',
            subtitleKey: 'signup.steps.FDB.process.info_collection',
            youAreHere: false
          },
          {
            icon: 'mdiCarClock',
            iconColor: 'primary',
            titleKey: 'signup.steps.FDB.process.awaiting_openings',
            subtitleKey: 'signup.steps.FDB.process.you_are_here',
            youAreHere: true
          },
          {
            icon: 'mdiFileSearchOutline',
            iconColor: 'grey',
            titleKey: 'signup.steps.FDB.process.documents',
            subtitleKey: 'signup.steps.FDB.process.document_colletion',
            youAreHere: false
          },
          {
            icon: 'mdiFilterOutline',
            iconColor: 'grey',
            titleKey: 'signup.steps.FDB.process.selection',
            subtitleKey: null,
            youAreHere: false
          }
        ]
      },
      openning: {
        toggle: false,
        text: '',
        date: '',
      },
      faq: [
        {
          section: 'signup',
          item: 1,
        },
        {
          section: 'signup',
          item: 2,
        },
        {
          section: 'signup',
          item: 4,
        },
        {
          section: 'signup',
          item: 5,
        },
      ],
      social: [
        {
          title: 'general.follow_us',
          icon: 'mdiInstagram',
          url: 'https://www.instagram.com/mobees_br/',
        },
        // {
        //   title: 'Site',
        //   icon: 'mdiWeb',
        //   url: 'https://mobees.com.br/',
        // },
        // {
        //   title: 'Blog',
        //   icon: 'mdiPostOutline',
        //   url: 'https://blog.mobees.com.br/',
        // },
      ],
      btnLocation: {
        toggle: true,
        loading: false,
      },
      installed: Capacitor.isNativePlatform(),
    }),

    computed: {
      profileView: sync('app/views@profile'),
      status: sync('user/status'),
      user: sync('user'),
      gps: sync('user/profile@gps'),
      toast: sync('app/toast'),
      help: sync('app/views@help'),
      help_sections: sync('help/sections'),

      showEvaluation () {
        const serviceModel = this.user.profile.job.service_model;
        return serviceModel!='Tx';
      },

      evaluationColor () {
        const score = this.step.evaluation.score;
        let color = 'red';
        if (score>=.8) {
          color = 'primary darken-1';
        }else if (score>=.6) {
          color = 'light-green';
        }else if (score>=.4) {
          color = 'yellow';
        }else if (score>=.2) {
          color = 'orange';
        }
        return color;
      },

      stepName () {
        return this.$options.name.toLowerCase();
      },

      timelineItems () {
        const timeline = this.timeline;
        const order = timeline.order[this.user.express ? 1 : 0];
        const items = _.cloneDeep(timeline.items);
        let here = true;
        return order.map(index => {
          items[index].iconColor = here ? 'primary' : 'grey';
          if (items[index].youAreHere) here = false;
          return items[index];
        });
      }
    },

    methods: {
      ...services,

      actionCalled () {
        // no action
      },

      updateView () {

      },

      getFeedback (item) {
        const dict = this.$i18n.messages[this.$i18n.locale];
        const val = item.valor.toString().replace('.', '-');
        const path = 'signup.steps.FDB.feedbacks.'+item.criteria+'.'+(val in _.get(dict, 'signup.steps.FDB.feedbacks.'+item.criteria) ? val : 'text');
        
        return this.$t(path);
      },

      openURL (url) {
        window.open(url);
      },

      async enableGeolocation () {
        if (this.installed) {
          const cpf = this.rawCPF(this.user.cpf);
          const token = this.user.auth.token;
          mobees.requestGpsPermission((result) => {
            mobees.hasGpsPermission((result) => {
              this.gps = (result=='true');
              console.log('GPS: '+this.gps);
              
              this.$api.post('/setgeolocationpermission', {
                cpf: cpf,
                authTk: token,
                permitted: this.gps
              })
              .then(response => {
                console.log('setGeolocationPermission => ', response);
                if(response.data.retorno==200){
                  // saved
                  this.trackEvent('geolocation', this.gps ? 'enabled' : 'disabled');
                }else{
                  this.trackEvent('geolocation', 'set state error');
                }
              })
            }, () => {
              // TODO handle native access error
            });
          });
        }
      },

      getEvaluation () {
        const token = this.user.auth.token;
        const cpf = this.rawCPF(this.user.cpf);

        this.$api({
          url: '/getevaluationdriver',
            method: 'POST',
            data: {
              cpf: cpf,
              authTk: token,
            }
          })
          .then(response => {
            console.log('getEvaluationDriver => ',response);
            if(response.data.retorno==200){
              const status = _.has(response.data, 'status_motorista') ? response.data.status_motorista : 'FDB';
              const step = this.step;
              step.evaluation.score = response.data.score;
              step.evaluation.feedbacks = response.data.feedbacks;
              if (!this.showEvaluation) {
                step.title = 'signup.steps.FDB.waiting';
              }
              if (step.evaluation.feedbacks.length==0) {
                step.subtitle = 'signup.steps.FDB.feedbacks.brief.nice';
              }else{
                step.subtitle = 'signup.steps.FDB.feedbacks.brief.ok';
              }
              this.$emit('update', step);
              
              if (this.status!=status) {
                this.status = status;
                this.$emit('next', { status });
              }

              this.trackEvent('signup/'+this.stepName, 'get evaluation ok');
            }else{
              this.toggleToast(
                true,
                this.$t('signup.steps.FDB.errors.get'),
                5000,
                false,
              );
              this.trackEvent('signup/'+this.stepName, 'request evaluation failed');
            }
          })
          .catch(error => {
            this.handleError(error);
          })
          .finally(() => {
            // If we couldn't load the evaluation, stop the loading state
            // so the user doesn't see an infinite progress bar.
            // if (this.step.evaluation.score === null) {
            //   const step = this.step;
            //   step.evaluation.score = 0;
            //   step.evaluation.feedbacks = step.evaluation.feedbacks || [];
            // }
          });
      },

      getNextOpenning () {
        const token = this.user.auth.token;
        const cpf = this.rawCPF(this.user.cpf);

        this.$api({
          url: '/getnextopenningdriver',
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            data: {
              cpf: cpf,
              authTk: token,
            }
          })
          .then(response => {
            console.log('getNextOpenning => ',response);
            if(response.data.retorno==200){
              this.openning.toggle = true;
              this.openning.text = response.data.text;
              this.openning.date = response.data.date;

            }else{
              // this.toggleToast(
              //   true,
              //   'Não foi possível carregar sua avaliação.',
              //   5000,
              //   false,
              // );
            }
          })
          .catch(error => {
            this.handleError(error);
          })
          .finally(() => {
            
          });
      },

    },

    created () {
    },

    mounted () {
      this.getEvaluation();
      this.getNextOpenning();
    },

    directives: {
    },

  }
</script>
